import React, { useState, useEffect } from 'react';
import './EditUserModal.css';

function EditUserModal({ user, onSave, onClose }) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    mobileNumber: '',
    countryCode: '+91',
    isActive: true
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        emailId: user.emailId || '',
        mobileNumber: user.mobileNumber || '',
        countryCode: user.countryCode || '+91',
        isActive: user.isActive
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (formData.emailId && !/^\S+@\S+\.\S+$/.test(formData.emailId)) {
      newErrors.emailId = 'Invalid email format';
    }

    if (formData.mobileNumber) {
      if (!/^\d{10}$/.test(formData.mobileNumber)) {
        newErrors.mobileNumber = 'Invalid mobile number (10 digits required)';
      }
      if (!formData.countryCode) {
        newErrors.countryCode = 'Country code is required';
      }
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const dataToSend = {
      id: user.id,
      ...formData
    };

    // Remove empty email
    if (!formData.emailId.trim()) {
      delete dataToSend.emailId;
    }

    onSave(dataToSend);
  };

  const countryCodes = [
    { value: '+91', label: 'India (+91)' },
    { value: '+1', label: 'USA (+1)' }
  ];

  if (!user) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Edit User: {user.firstName} {user.lastName}</h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <form onSubmit={handleSubmit} className="edit-user-form">
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className={errors.firstName ? 'error' : ''}
            />
            {errors.firstName && <span className="error-text">{errors.firstName}</span>}
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="emailId"
              value={formData.emailId}
              onChange={handleChange}
              placeholder="user@example.com"
              className={errors.emailId ? 'error' : ''}
            />
            {errors.emailId && <span className="error-text">{errors.emailId}</span>}
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Country Code</label>
              <select
                name="countryCode"
                value={formData.countryCode}
                onChange={handleChange}
                className={errors.countryCode ? 'error' : ''}
              >
                {countryCodes.map(code => (
                  <option key={code.value} value={code.value}>
                    {code.label}
                  </option>
                ))}
              </select>
              {errors.countryCode && <span className="error-text">{errors.countryCode}</span>}
            </div>

            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                placeholder="9876543210"
                className={errors.mobileNumber ? 'error' : ''}
              />
              {errors.mobileNumber && <span className="error-text">{errors.mobileNumber}</span>}
            </div>
          </div>

          {/* Show isActive toggle only for admin users */}
          {user.providerTypes?.some(type => type.type === 'admin') && (
            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                />
                <span className="checkbox-label">Active User</span>
              </label>
            </div>
          )}

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-save">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUserModal;